import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { DividerModule } from 'primeng/divider';
import { ImageModule } from 'primeng/image';
import { SelectModule } from 'primeng/select';
import { TabsModule } from 'primeng/tabs';
import { MisureIntersezioneComponent } from './misure-intersezione/misure-intersezione.component';
import { MisureSempliciDoppiComponent } from './misure-semplici-doppi/misure-semplici-doppi.component';
import { MisureCuoreComponent } from './misure-cuore/misure-cuore.component';

@Component({
    selector: 'app-misure',
    templateUrl: './misure.component.html',
    imports: [DividerModule, DatePickerModule, CommonModule, SelectModule, ImageModule, ReactiveFormsModule, TabsModule, MisureSempliciDoppiComponent, MisureIntersezioneComponent, MisureCuoreComponent],
    standalone: true
})
export class MisureComponent {
    @Input() deviatoio: any;
    @Input() form!: FormGroup;
    @Input() normativa: any;
    @Input() formReady: boolean = false;
    @Input() mode: string = 'edit';

    // per cambiare tab dall’esterno se serve
    @Input() selectedTab: string = 'ramo1';
    @Input() selectedTabIntersezione: string = 'telaio1';

    @Output() selectedTabChange = new EventEmitter<string>();
    @Output() selectedTabIntersezioneChange = new EventEmitter<string>();

    onTabChange(tab: any) {
        this.selectedTab = tab;
        this.selectedTabChange.emit(tab);
    }

    onTabIntersezioneChange(tab: any) {
        this.selectedTabIntersezione = tab;
        this.selectedTabIntersezioneChange.emit(tab);
    }

    getNormativaByTab(tab: string): any | null {
        return this.normativa?.find((n: any) => n.tab === tab) ?? null;
    }
}
